import { render, staticRenderFns } from "./ClientRoadmapCard.vue?vue&type=template&id=2ee276b3&"
import script from "./ClientRoadmapCard.vue?vue&type=script&lang=ts&"
export * from "./ClientRoadmapCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports